/**
 * One-line descriptions per nav destination, for the mobile More page and the
 * ⌘K palette. Tool routes reuse the hub tile copy (shared TOOLS registry) so
 * there is one source; the rest are written here.
 */
import { TOOLS, type ToolSlug } from '@daaily/shared';

const ROUTE_TO_SLUG: Record<string, ToolSlug> = {
  '/expenses': 'expenses', '/invoices': 'invoices', '/credit-cards': 'creditCards', '/drivers': 'drivers',
  '/absence': 'absence', '/documents': 'documents', '/org': 'orgChart', '/time': 'timeTracking',
  '/performance-reviews': 'performanceReviews', '/commissions': 'commissions', '/usl': 'usl',
  '/subscriptions': 'subscriptions', '/analytics': 'analytics', '/signatures': 'signatures',
  '/projects': 'projects', '/newsletter': 'newsletter', '/operations': 'operations',
  '/outreach': 'outreach', '/business-card': 'businessCard', '/directors': 'directors',
};

const OTHER: Record<string, string> = {
  '/': 'Your hub: tools, to-dos and what is new.',
  '/my-team': 'Your reports: open asks, absences and statements.',
  '/onboarding': 'On- and offboarding and parental leave checklists you are on.',
  '/share-receipt': 'Send a receipt to a colleague who holds the card.',
  '/activity': 'Everything waiting on you, across every tool.',
  '/crm': 'Test rebuild of Salesforce, as its own app.',
  '/guide': 'What each of your apps does, and answers to your questions.',
  '/profile': 'Your details, preferences and theme.',
  '/admin': 'Users, who has access to what, and hub settings.',
  '/admin/config': 'Tool configuration and email senders.',
  '/admin/fte': 'Headcount and FTE by team.',
  '/admin/mutations': 'The monthly HR checklist and payroll PDFs.',
  '/admin/performance-reviews': 'Review cycles, surveys and results.',
  '/admin/onboarding': 'On- and offboarding templates and checklists.',
  '/document-vault': 'Employee and company documents, set-up side.',
};

export function navDescription(to: string): string | undefined {
  const slug = ROUTE_TO_SLUG[to];
  return slug ? TOOLS[slug].description : OTHER[to];
}
